import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DynamicLoaderComponent } from './dynamic-loader.component';
import { DynamicLoaderRoutingModule } from './dynamic-loader-routing.module';

const exportableComponents = [
    DynamicLoaderComponent
];

@NgModule({
    imports: [
        CommonModule,
        DynamicLoaderRoutingModule,
    ],
    declarations: exportableComponents,
    exports: exportableComponents,
    entryComponents: exportableComponents,
})
export class DynamicLoaderModule {}
